// src/components/ui/RoleView.jsx
import React from 'react';

const RoleView = ({ allowedRole, children }) => {
  const user = JSON.parse(localStorage.getItem('user'));
  if (!user || user.role !== allowedRole) return null;
  return <>{children}</>;
};

export default RoleView;
